import {UserProfile} from '@shared/interfaces';
import {User} from '@firebase/auth';

export enum ActionTypes {
  GET_USER = '[Auth] GetUser',
  SET_INIT = '[Auth] SetInit',
  CHECK_SESSION = '[Auth] CheckSession',
  DELETE_USER = '[Auth] DeleteUser',
  LOGIN = '[Auth] Login',
  GOOGLE_LOGIN = '[Auth] GoogleLogin',
  FACEBOOK_LOGIN = '[Auth] FacebookLogin',
  ANON_LOGIN = '[Auth] AnonymousLogin',
  REGISTER_ANON_TO_EMAIL = '[Auth] RegisterAnonToEmail',
  LINK_ANON_TO_EMAIL = '[Auth] LinkAnonToEmail',
  LINK_ANON_TO_GOOGLE = '[Auth] LinkAnonAcctToGoogle',
  LINK_ANON_TO_FACEBOOK = '[Auth] LinkAnonAcctToFacebook',
  LINK_ACCT_TO_GOOGLE = '[Auth] LinkAcctToGoogle',
  LINK_ACCT_TO_FACEBOOK = '[Auth] LinkAcctToFacebook',
  UNLINK_ACCT_FROM_GOOGLE = '[Auth] UnlinkAcctFromGoogle',
  UNLINK_ACCT_FROM_FACEBOOK = '[Auth] UnlinkAcctFromFacebook',
  LOGIN_SUCCESS = '[Auth] LoginSuccess',
  LOGIN_FAILURE = '[Auth] LoginFailure',
  LOGIN_REDIRECT = '[Auth] LoginRedirect',
  LOGOUT = '[Auth] Logout',
  LOGOUT_SUCCESS = '[Auth] LogoutSuccess',
  REGISTER = '[Auth] Register',
  EDIT_USER = '[Auth] EditUser',
  RESET_PASSWORD = '[Auth] ResetPassword',
  CHANGE_PASSWORD = '[Auth] ChangePassword',
  UPDATE_USER_PREFERENCE = '[Auth] UpdateUserPreference',
  REFRESH_TOKEN = '[Auth] RefreshToken'
}

export class GetUser {
  static readonly type = ActionTypes.GET_USER;

  constructor(public payload: Partial<User>) {
  }
}

export class SetInit {
  static readonly type = ActionTypes.SET_INIT;

  constructor(public payload?: { url?: string; canNavigate?: boolean }) {
  }
}

export class CheckSession {
  static readonly type = ActionTypes.CHECK_SESSION;

  constructor(public payload?: { url?: string; canNavigate?: boolean }) {
  }
}

export class DeleteUser {
  static readonly type = ActionTypes.DELETE_USER;
}

export class Login {
  static readonly type = ActionTypes.LOGIN;

  constructor(public payload: { email: string, password: string; redirectLink: string; }) {
  }
}

export class GoogleLogin {
  static readonly type = ActionTypes.GOOGLE_LOGIN;

  constructor(public payload: { linkType: 'login', redirectLink: string }) {
  }
}

export class FacebookLogin {
  static readonly type = ActionTypes.FACEBOOK_LOGIN;

  constructor(public payload: { linkType: 'login', redirectLink: string }) {
  }
}

export class AnonLogin {
  static readonly type = ActionTypes.ANON_LOGIN;
}

export class LoginSuccess {
  static readonly type = ActionTypes.LOGIN_SUCCESS;

  constructor(public payload: User) {
  }
}

export class LoginFailure {
  static readonly type = ActionTypes.LOGIN_FAILURE;

  // Payload is error object
  constructor(public payload: any) {
  }
}

export class LoginRedirect {
  static readonly type = ActionTypes.LOGIN_REDIRECT;

  constructor(public redirectUrl: any) {
  }
}

export class Logout {
  static readonly type = ActionTypes.LOGOUT;
}

export class LogoutSuccess {
  static readonly type = ActionTypes.LOGOUT_SUCCESS;
}

export class Register {
  static readonly type = ActionTypes.REGISTER;

  constructor(public payload: { email: string, password: string, redirectLink: string, [k: string]: any }) {
  }
}

export class RegisterAnonToEmail {
  static readonly type = ActionTypes.REGISTER_ANON_TO_EMAIL;

  constructor(public payload: {
    email: string, password: string, linkType: 'register', redirectLink: string,
    [k: string]: any
  }) {
  }
}

export class LinkAnonToEmail {
  static readonly type = ActionTypes.LINK_ANON_TO_EMAIL;

  constructor(public payload: {
    email: string, password: string, linkType: 'login', redirectLink: string,
    [k: string]: any
  }) {
  }
}

export class LinkAnonAcctToGoogle {
  static readonly type = ActionTypes.LINK_ANON_TO_GOOGLE;

  constructor(public payload: { linkType: 'login', redirectLink: string }) {
  }
}

export class LinkAnonAcctToFacebook {
  static readonly type = ActionTypes.LINK_ANON_TO_FACEBOOK;

  constructor(public payload: { linkType: 'login', redirectLink: string }) {
  }
}

export class LinkAcctToGoogle {
  static readonly type = ActionTypes.LINK_ACCT_TO_GOOGLE;

  constructor(public payload: { linkType: 'login', redirectLink: string }) {
  }
}

export class LinkAcctToFacebook {
  static readonly type = ActionTypes.LINK_ACCT_TO_FACEBOOK;

  constructor(public payload: { redirectLink: string }) {
  }
}

export class UnlinkAcctFromGoogle {
  static readonly type = ActionTypes.UNLINK_ACCT_FROM_GOOGLE;

  constructor(public payload: { redirectLink: string }) {
  }
}

export class UnlinkAcctFromFacebook {
  static readonly type = ActionTypes.UNLINK_ACCT_FROM_FACEBOOK;

  constructor(public payload: { redirectLink: string }) {
  }
}

export class EditUser {
  static readonly type = ActionTypes.EDIT_USER;

  constructor(public payload: { userData: UserProfile }) {
  }
}

export class ResetPassword {
  static readonly type = ActionTypes.RESET_PASSWORD;

  constructor(public payload: { email: string }) {
  }
}

export class ChangePassword {
  static readonly type = ActionTypes.CHANGE_PASSWORD;

  constructor(public payload: any) {
  }
}

export class UpdateUserPreference {
  static readonly type = ActionTypes.UPDATE_USER_PREFERENCE;

  constructor(public payload: { key: string; value: boolean; }) {
  }
}

export class RefreshToken {
  static readonly type = ActionTypes.REFRESH_TOKEN;
}
